import { AppStateUserProfile } from "../redux/userProfile/";
import { AppStateLogin } from "./auth";
import { AppStateDevicesState } from "./devices";
import { AppStateDevicesStatus } from "./devicesStatuses";
import { AppStateHealthCheck } from "./healthCheck";
import { AppStateModalFeedback } from "./modalFeedback";
import { AppStateMonitorAlerts } from "./alerts";
import { AppStateRepeatAlert } from "./repeatAlert";
import { AppStateResidentsStatus } from "./residentStatuses";
import { AppStateResidents } from "./residents/";
import { AppStateNotification } from "./newNotification/types";
import { AppStatePreloader } from "./preloader/types";
import { AppsStateOrganization } from "./organization";
import { AppsStateUsersState } from "./users";
import { AppStateResidentsActivityPlan } from "./residentActivityPlan";
import { AppStateUserActivity } from "./userActivity/types";
// The top-level state object

// The top-level state object
export interface IAppState {
  auth: AppStateLogin;
  alerts: AppStateMonitorAlerts;
  devices: AppStateDevicesState;

  userProfile: AppStateUserProfile;

  notification: AppStateNotification;
  notificationSound: boolean;

  preloader: AppStatePreloader;
  residents: AppStateResidents;
  feedback: AppStateModalFeedback;
  devicesStatuses: AppStateDevicesStatus;
  residentStatuses: AppStateResidentsStatus;
  repeatAlert: AppStateRepeatAlert;
  healthCheck: AppStateHealthCheck;
  organization: AppsStateOrganization;
  users: AppsStateUsersState;
  residentActivityPlan: AppStateResidentsActivityPlan;
  userActivity: AppStateUserActivity;
}

export enum MenuItem {
  MONITOR = "monitor",
  DEVICES = "devices",
  REPORTS = "reports",
  SETTINGS = "settings",
}
export enum SortDirection {
  ASC = "ASC",
  DESC = "DESC",
}
